import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState } from 'recoil';
import dayjs from 'dayjs';
import {
  Button,
  Popconfirm,
  Modal,
  Select
} from 'antd';
import {
  notificationsAtom,
  markLeadLostAtom,
  viewLeadAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';

function MarkLostModal() {
  const { Option } = Select;
  const { t, i18n } = useTranslation();
  const setLeadData = useSetRecoilState(viewLeadAtom);
  const [lead, setLead] = useRecoilState(markLeadLostAtom);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);

  function markLost() {
    setLoading(true);
    api.post(`leads/lost/${lead.id}?reason=${reason}`, null)
      .then((response) => {
        setLoading(false);
        if (response?.data?.error) {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        } else {
          setNotifications([
            ...notifications,
            {
              title: t('success'),
              description: response.data.message,
              error: false,
            },
          ]);
          setLead(null);
          setLeadData({
            ...response.data.data,
            contactedOn: response.data.data.contactedOn ? dayjs(response.data.data.contactedOn).add(4, 'hour') : null,
            appointmentDateTime: response.data.data.appointmentDateTime ? dayjs(response.data.data.appointmentDateTime).add(4, 'hour') : null,
            proposalDate: response.data.data.proposalDate ? dayjs(response.data.data.proposalDate).add(4, 'hour') : null,
            signedDate: response.data.data.signedDate ? dayjs(response.data.data.signedDate).add(4, 'hour') : null,
            siteSurveyDateScheduled: response.data.data.siteSurveyDateScheduled ? dayjs(response.data.data.siteSurveyDateScheduled).add(4, 'hour') : null,
            siteSurveyDate: response.data.data.siteSurveyDate ? dayjs(response.data.data.siteSurveyDate).add(4, 'hour') : null,
            installationDate: response.data.data.installationDate ? dayjs(response.data.data.installationDate).add(4, 'hour') : null,
            installationDateScheduled: response.data.data.installationDateScheduled ? dayjs(response.data.data.installationDateScheduled).add(4, 'hour') : null,
            activationDate: response.data.data.activationDate ? dayjs(response.data.data.activationDate).add(4, 'hour') : null
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  useEffect(() => {
    setReason('');
  }, [lead]);

  return (
    <Modal
      title={t('select_lost_reason')}
      open={lead}
      onCancel={() => setLead(null)}
      footer={[
        <Button
          key="ok"
          type="primary"
          danger
          disabled={loading}
          onClick={() => setLead(null)}
        >
          {t('cancel')}
        </Button>,
        <Popconfirm
          title={t('mark_as_lost_prompt')}
          okText={t('yes')}
          cancelText={t('no')}
          onConfirm={() => markLost()}
        >
          <Button
            key="ok"
            type="primary"
            disabled={reason === ''}
            loading={loading}
          >
            {t('submit')}
          </Button>
        </Popconfirm>
      ]}
    >
      <Select
        className="w-full h-12"
        value={reason}
        disabled={loading}
        onChange={(obj) => setReason(obj)}
      >
        <Option value="">{t('select_reason')}</Option>
        <Option value={2}>{t('disengaged')}</Option>
        <Option value={1}>{t('failed_credit')}</Option>
        <Option value={0}>{t('cancelled')}</Option>
        <Option value={3}>{t('competitor_proposal')}</Option>
      </Select>
    </Modal>
  );
}

export default MarkLostModal;
